//Components
import Chip from '@mui/material/Chip'
import Module from '../../../layout/Module'
import DataGrid from '../../../table/DataGrid'
import TextAuditLog from '../../../text/TextAuditLog'
import IconTooltipButton from '../../../button/IconTooltipButton'
import FormatDate from '../../../date/FormatDate'
import ResponsiveChips from '../components/ResponsiveChips/ResponsiveChips'

//Other dependencies dataEntryAssessment
import { useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { loadAssessments } from '../../../../store/actions/dataEntryAssessmentActions'
import { resetAssessmentMarkingState } from '../../../../store/actions/dataEntryAssessmentMarkingActions'
import { updateSkip, updateRowsPerPage } from '../../../../store/actions/datatable.actions'
import { alertReset } from '../../../../store/actions/alert.actions'
import { useDispatch, useSelector } from 'react-redux'
import { ASSESSMENT_TYPE_STANDARD } from '../constants/typeAssessment'
import StatusChip from '../components/StatusChip/StatusChip'

//Filter
import Filter from '../Assessments/FilterList/Filter'

const MyAssessmentsList = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const currentModule = 'dataentrymyassessments'
  const permissions = useSelector((state) => state?.session?.permissions?.dataentrymyassessments ?? {})
  const list = useSelector((state) => state?.dataEntryAssessment?.assessments?.list ?? [])
  const loading = useSelector((state) => state?.dataEntryAssessment?.assessments?.loading ?? [])
  const totalRecords = useSelector((state) => state?.dataEntryAssessment?.assessments?.totalRecords ?? [])
  const skip = useSelector((state) => state?.datatable?.assessmentList?.skip || 0)
  const rowsPerPage = useSelector((state) => state?.datatable?.assessmentList?.rowsPerPage || 100)
  const columnsTable = useSelector((state) => state?.datatable?.assessmentList?.columnsTable || [])
  const user = useSelector((state) => state?.session?.user)
  const state = useSelector((state) => state?.filter?.dataEntryMyAssessment || {})

  const onLoadData = useCallback(() => {
    const filter = { ...state?.filter, userId: user?.userId }
    delete filter?.template
    delete filter?.yearLevel

    dispatch(loadAssessments(skip * rowsPerPage, rowsPerPage, filter))
    dispatch(alertReset())
  }, [skip, rowsPerPage, state?.filter])

  useEffect(() => {
    onLoadData()
  }, [onLoadData])

  const setCurrentRow = async (row, action) => {
    const data = JSON.parse(JSON.stringify(list.find((x) => x._id === row._id)))

    if (data) {
      if ('marking' === action) {
        dispatch(resetAssessmentMarkingState())
        dispatch(updateSkip('assessmentMarking', 0))
        dispatch(updateRowsPerPage('assessmentMarking', 25))

        navigate(`/dashboard/data-entry/assessment-marking/${row._id}`, {
          state: { from: '/dashboard/data-entry/my-assessments' }
        })
      }
    }
  }

  return (
    <Module>
      <Module.Header
        moduleName={currentModule}
        title='My Assessments'
        titleLink={'/dashboard/data-entry/my-assessments'}
      />
      <Module.BodyHeader py='4' className='border-b border-b-2 border-primary'>
        <Filter module='dataEntryMyAssessment' />
      </Module.BodyHeader>
      <Module.BodyContainer className='overflow-y-auto'>
        <DataGrid
          className='pb-6'
          id='table-assessments'
          rows={list.map((row, index) => ({
            ...row,
            index: index + 1,
            name: row.name ?? '',
            yearLevel: (
              <ResponsiveChips
                minDisplay={3}
                maxDisplay={10}
                chipVariant='outlined'
                items={row?.template?.yearLevels ?? []}
                field='name'
              />
            ),
            class: <ResponsiveChips minDisplay={3} maxDisplay={20} items={row?.classes ?? []} field='code' />,
            template: row?.template?.title ?? '',
            type: (
              <Chip
                label={row?.type?.replace(/-/g, ' ')}
                size='small'
                className='uppercase'
                color={row?.type === ASSESSMENT_TYPE_STANDARD ? 'primary' : 'secondary'}
              />
            ),
            sittingDate: row?.sittingDate ? <FormatDate date={row?.sittingDate} /> : null,
            dueDate: row?.dueDate ? <FormatDate date={row?.dueDate} /> : null,
            date: row?.date ? <FormatDate date={row?.date} /> : null,
            status: (
              <StatusChip
                content={row?.status ?? 'Closed'}
                type={row?.status === 'Closed' ? 'error' : 'done'}
              />
            ),
            log: (
              <TextAuditLog
                updatedAt={row.updatedAt}
                updatedBy={row.updatedBy}
                createdBy={row.createdBy}
                createdAt={row.createdAt}
              />
            ),
            note: row?.notes ?? '',
            actions: (
              <div className='flex items-center gap-1 items-center justify-center'>
                {permissions?.marking && (
                  <IconTooltipButton
                    id={`marking-${row._id}`}
                    disabled={loading}
                    title='Marking'
                    icon='pencil-mechanical'
                    onClick={() => setCurrentRow(row, 'marking')}
                  />
                )}
              </div>
            )
          }))}
          loading={loading}
          labelNoRows='No assessments found'
          nameModule='assessmentList'
          headers={[...columnsTable]}
          totalRows={totalRecords}
          skip={skip}
          rowsPerPage={rowsPerPage}
          columns={[
            {
              label: '#',
              key: 'index',
              align: 'center',
              width: 10,
              show: true,
              hide: false
            },
            ...columnsTable,
            {
              label: 'Actions',
              key: 'actions',
              align: 'center',
              show: true,
              hide: false
            }
          ]}
          orderByField='name'
        />
      </Module.BodyContainer>
    </Module>
  )
}
export default MyAssessmentsList
